
<script>
  import { Doughnut } from 'vue-chartjs'
 
  export default {
    extends: Doughnut,
    props: ['data', 'options'],

    mounted () {
      this.renderChart(this.data, this.options)
    },

    methods: {
		 printDonutGraphe(){
		 	let imageValue = this.$refs.canvas.toDataURL()

      var downloadLink = document.createElement('a');
			downloadLink.href = imageValue;
			downloadLink.download = 'Graphe_donut.png';

			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		 },		 
		}

  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/DoughnutChart.vue